import { scenarioApi } from '@mathflat/domain/Scenario'
import type { Scenario, SubScenario } from 'src/dto'

import { mpEventInfo } from '@/constant'

class ScenearioController {
  async fetchUserScenario() {
    const unitIds = await scenarioApi.getScenarioUnitIds({
      mp_event_name: mpEventInfo.시나리오_유저_조회,
    })
    return new Set(unitIds)
  }

  async postScenario(id: Scenario['id'] | SubScenario['id']) {
    await scenarioApi.createScenarioActionLog(
      { unitId: id },
      { mp_event_name: mpEventInfo.시나리오_유저_수행 },
    )
  }

  async fetchLastAssginedStudentId() {
    return scenarioApi.getScenarioLatestAssignedStudentId({
      mp_event_name: mpEventInfo.시나리오_마지막_출제학생,
    })
  }

  async fetchLastScoredStudentId() {
    return scenarioApi.getScenarioLatestScoredStudentId({
      mp_event_name: mpEventInfo.시나리오_마지막_채점학생,
    })
  }

  async unLikeSubScenario(id: SubScenario['id']) {
    await scenarioApi.deleteScenarioActionLog(
      { unitId: id },
      { mp_event_name: mpEventInfo.시나리오_유저_수행취소 },
    )
  }
}

export const scenarioController = new ScenearioController()
